var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.493 6.327L8.41 10.41a.56.56 0 01-.41.173.56.56 0 01-.41-.173L3.505 6.327a.56.56 0 01-.173-.41.56.56 0 01.173-.41.561.561 0 01.41-.174h8.167a.56.56 0 01.41.173.561.561 0 01.173.41.561.561 0 01-.173.41z"}));
}

Arrow.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Arrow;

Arrow.default = Arrow;
